module.exports = __webpack_public_path__ + "img/EJE_REFORZADO_MENOR.48d6c255.png";